// src/store/slice/design/documentElementsSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DocumentElement {
  processId: number;
  processName: string;
  docTypeID: number;
  docTypeName: string;
}

interface DocumentElementsState {
  elements: DocumentElement[];
  selectedProcessID: number | null;
  selectedDocTypeID: number | null;
}

const initialState: DocumentElementsState = {
  elements: [],
  selectedProcessID: null,
  selectedDocTypeID: null
};

const documentElementsSlice = createSlice({
  name: 'documentElements',
  initialState,
  reducers: {
    setDocumentElements(state, action: PayloadAction<DocumentElement[]>) {
      state.elements = action.payload;
    },
    setSelectedProcessID(state, action: PayloadAction<number | null>) {
      state.selectedProcessID = action.payload;
    },
    setSelectedDocTypeID(state, action: PayloadAction<number | null>) {
      state.selectedDocTypeID = action.payload;
    },
    resetDocumentElements(state) {
      state.elements = initialState.elements;
      state.selectedProcessID = initialState.selectedProcessID;
      state.selectedDocTypeID = initialState.selectedDocTypeID;
    }
  }
});

export const { setDocumentElements, setSelectedProcessID, setSelectedDocTypeID, resetDocumentElements } = documentElementsSlice.actions;

export default documentElementsSlice.reducer;
